export { default } from './pharmaprix-pharmacist-owners.component';
